import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MapComponent } from './map/map.component';
import { LocationComponent } from './location/location.component';
import { MapLeafletModule } from './map-leaflet/map-leaflet.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
// import { GMapModule } from 'primeng/gmap';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CreateCediPointComponent } from './create-cedi-point/create-cedi-point.component';
import { LoadingComponent } from './loading/loading.component';
import { TranslateModule } from '@ngx-translate/core';
import { MuToastComponent } from './mu-toast/mu-toast.component';

import { MultiSelectModule } from 'primeng/multiselect';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

const components = [MapComponent, LocationComponent, CreateCediPointComponent, LoadingComponent, MuToastComponent];
@NgModule({
  declarations: [...components],
  imports: [
    TranslateModule.forChild({}),
    CommonModule,
    ButtonModule,
    DialogModule,
    MapLeafletModule,
    AutoCompleteModule,
    RadioButtonModule,
    // GMapModule,
    FormsModule,
    ToastModule,
    ReactiveFormsModule,
    MultiSelectModule,
  ],
  exports: [...components],
  providers: [MessageService],
})
export class SharedModule {}
